import SearchBarInput from '@components/ui/search/SearchBarInputNext/SearchBarInput';
import CustomIcon from '@components/utils/CustomIcon';
import { PersonIcon } from '@assets/icons';
import {
  FlightGuestProps,
  FlightSearchBarProps,
} from '@components/views/flight/types';
import { getGuestText } from '@components/views/flight/utils';
import { useSkipEffectOnMount } from '@hooks/lifecycle';

import FlightGuestBox from '../guest-box-flight/FlightGuestBox';
import useFlightGuests from '../guest-box-flight/useFlightGuests';

type Props = {
  guestInfo: FlightGuestProps;
  className?: string;
  isBookerSearch?: boolean;
  setButtonDisable?: React.Dispatch<React.SetStateAction<boolean>>;
  isControlDisable?: boolean;
  isDateError: boolean;
  borderRadius?: string;
} & Pick<FlightSearchBarProps, 'onApplyGuestsForm'>;

const SearchBarFlightGuestBox = ({
  guestInfo,
  onApplyGuestsForm,
  className,
  isBookerSearch,
  setButtonDisable,
  isControlDisable = true,
  isDateError,
  borderRadius,
}: Props) => {
  const {
    numberOfAdultGuests,
    numberOfChildGuests,
    numberOfInfantGuests,
    removeAdult,
    addAdult,
    removeChild,
    addChild,
    removeInfant,
    addInfant,
    errorMessages,
    reset,
  } = useFlightGuests(guestInfo, onApplyGuestsForm);
  useSkipEffectOnMount(() => {
    if (isControlDisable && !isDateError) {
      setButtonDisable?.(true);
    }
  }, [numberOfAdultGuests, numberOfChildGuests, numberOfInfantGuests]);
  return (
    <div className={className} style={{ maxWidth: '220px' }}>
      <SearchBarInput
        borderRadius={borderRadius ?? '0 0 8px 8px'}
        label='Kaç kişi yolculuk yapacaksınız?'
        InputComponent={getGuestText(guestInfo)}
        isBookerSearch={isBookerSearch}
        leftIcon={() => (
          <CustomIcon fontSize={20} paletteColor='coral' icon={PersonIcon} />
        )}
        popoverProps={{
          align: 'start',
          onClickOutside: () => {
            reset();
          },
        }}
        isFilled={
          numberOfAdultGuests > 0 ||
          numberOfChildGuests > 0 ||
          numberOfInfantGuests > 0
        }
        renderOverlayContent={(closePopup) => {
          return (
            <FlightGuestBox
              onApplyGuestsForm={(guestInfoParam) => {
                onApplyGuestsForm(guestInfoParam);
                closePopup();
              }}
              numberOfAdultGuests={numberOfAdultGuests}
              numberOfChildGuests={numberOfChildGuests}
              numberOfInfantGuests={numberOfInfantGuests}
              onRemoveAdult={removeAdult}
              onAddAdult={addAdult}
              onRemoveChild={removeChild}
              onAddChild={addChild}
              onRemoveInfant={removeInfant}
              onAddInfant={addInfant}
              errorMessages={errorMessages}
            />
          );
        }}
      />
    </div>
  );
};

export default SearchBarFlightGuestBox;
